import React, { Component } from 'react';
import { Row, Col, Table, PanelGroup, Panel } from "react-bootstrap";

class BecaCarreras extends Component {
    state = {
        hist: false,
        iconChevron: "fa fa-chevron-down",
        btnDown: true,
    }

    cambiaIcon = (btn, icon, content) => {
        this.setState ({
            [btn]: !this.state[btn],
            [content]:!this.state[content],
        }, () => {
            (this.state[btn] === true) ? this.setState({[icon]: "fa fa-chevron-down"}) : this.setState({[icon]: "fa fa-chevron-up"})
        })
    }

    render() {
        let { historico } = this.props;
        let { hist, iconChevron, btnDown } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        let enLetras= (nota) => {
            let letras = [
                "UNO", "DOS", "TRES", "CUATRO", "CINCO", "SEIS", "SIETE", "OCHO", "NUEVE", "DIEZ",
                "ONCE", "DOCE", "TRECE", "CATORCE", "QUINCE", "DIECISEIS", "DIECISIETE", "DIECIOCHO",
                "DIECINUEVE", "VEINTE"
            ];
            return letras[nota - 1]
        }

        let mes = (num) => {
            let meses = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"]
            return meses[num - 1]
        }

        let materias = (materias) => {
            if (materias.length === 0) return (<div align="center">No existen materias registradas en este periodo</div>)

            return (
                materias.map(option => (
                    <tr key={option.id}>
                        <td align="center" style={{padding: 5, fontSize: 8}}>{option.Codigo}</td>
                        <td style={styles}>{option.Materia}</td>
                        <td align="center" style={styles}>{`${mes(option.Mes)} ${option.Year}`}</td>
                        <td align="center" style={styles}>{option.TE}</td>
                        <td align="center" style={styles}>{option.Nota}</td>
                        <td align="center" style={styles}>{enLetras(option.Nota)}</td>
                    </tr>
                ))
            )
        }

        let semestres = (sem) => {
            if (sem.length === 0) return (<div align="center">No existen periodos registrados en esta carrera</div>)
            
            return (
                sem.map (option => (
                    <div key={option.id} className="custom-sem-historico">
                        <div style={{padding: 5}}>
                            <Row>
                                <Col md={12} style={{paddingTop:10, paddingLeft: 20}}>
                                    <strong style={{marginTop:5}} className="text-danger">{option.Semestre}</strong>
                                </Col>
                            </Row>
                        </div>
                        <div className="custom-mt-10">
                            <div className="table-responsive" style={{backgroundColor:"#FFF"}}>
                                <Table striped hover bordered>
                                    <tbody>
                                        <tr className="custon-back-color">
                                            <td align="center" width="10%" style={styles}><strong>CÓDIGO</strong></td>
                                            <td width="45%" style={styles}><strong>MATERIA</strong></td>
                                            <td align="center" width="10%" style={styles}><strong>PERIODO</strong></td>
                                            <td align="center" width="10%" style={styles}><strong>T-E</strong></td>
                                            <td align="center" width="10%" style={styles}><strong>NOTA</strong></td>
                                            <td align="center" width="15%" style={styles}><strong>LETRAS</strong></td>
                                        </tr>
                                        {materias(option.Materias)}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                ))
            )
        }

        return (
            <PanelGroup accordion activeKey={hist} className="custom-alert-info custom-mt-10">
                <Panel eventKey = {true}>
                    <Panel.Heading onClick = {()=> {this.cambiaIcon( "btnDown", "iconChevron", "hist")}}>
                        <Panel.Title toggle className="custom-color">
                            <Row>
                                <Col md={10} style={{fontSize: 12}}>
                                    {historico.Carrera}
                                </Col>
                                <Col md={2} align="right">
                                    <i className={iconChevron}></i>
                                </Col>
                            </Row>
                        </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body collapsible style={{paddingLeft:5, paddingRight:5, paddingTop:10}}>
                        {semestres(historico.Semestres)}
                    </Panel.Body>
                </Panel>
            </PanelGroup>
        );
    }
}
 
export default BecaCarreras;


// WEBPACK FOOTER //
// ./src/views/Bienestar/BecaCarreras.jsx